export default __webpack_public_path__ + "static/media/red-2.3c9a5da2.svg";